import { config } from '~app/config';

import { uploadWithProgress } from '~shared/api/upload-with-progress';

import type {
  DocumentResponse,
  UploadPartnerApplicationDocumentRequest,
} from '../model';

export type UploadPartnerApplicationDocumentOptions = {
  onProgress?: (progress: number) => void;
  signal?: AbortSignal;
};

export function uploadPartnerApplicationDocument(
  request: UploadPartnerApplicationDocumentRequest,
  options?: UploadPartnerApplicationDocumentOptions
): Promise<DocumentResponse> {
  const formData = new FormData();
  formData.append('document', request.document);

  return uploadWithProgress<DocumentResponse>(
    `${config.apiHost}/merchant-origination/api/v1/public/partner/applications/document/upload`,
    formData,
    options?.onProgress,
    options?.signal
  );
}
